import { render } from "./Colors360Desktop.vue?vue&type=template&id=e66cb11c"
import script from "./Colors360Desktop.vue?vue&type=script&lang=js"
export * from "./Colors360Desktop.vue?vue&type=script&lang=js"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__